import { render, staticRenderFns } from "./NewPaymodel.vue?vue&type=template&id=6f98590a&scoped=true&"
import script from "./NewPaymodel.vue?vue&type=script&lang=js&"
export * from "./NewPaymodel.vue?vue&type=script&lang=js&"
import style0 from "./NewPaymodel.vue?vue&type=style&index=0&id=6f98590a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f98590a",
  null
  
)

export default component.exports